import { createSelector } from '@reduxjs/toolkit';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
// @ts-expect-error Untyped import
import { getConsentToProcessMessage as getConsentToProcessMessageOperator } from 'conversations-internal-schema/widget-data/operators/widgetDataGetters';
export const getConsentToProcessMessage = createSelector([getLatestWidgetData], widgetData => getConsentToProcessMessageOperator(widgetData));